export default "__VITE_ASSET__BgMfZxkF__"